import { Box, Typography, Alert } from '@mui/material';
import { errorAlertStyles } from './styles';

interface ErrorDisplayProps {
  errors?: string;
}

export const ErrorDisplay = ({ errors }: ErrorDisplayProps) => {
  if (!errors) {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  return (
    <Box>
      <Alert severity="error" sx={errorAlertStyles}>
        {errors}
      </Alert>
    </Box>
  );
};
